// Fix for menu initially displaying as vertical list
document.addEventListener('DOMContentLoaded', function () {
  // Force horizontal layout on initial render
  const inlineMenus = document.querySelectorAll('.header__inline-menu');
  const listMenus = document.querySelectorAll('.list-menu--inline');

  // Apply styles immediately
  inlineMenus.forEach((menu) => {
    menu.style.display = 'flex';
    menu.style.width = '100%';
    menu.style.justifyContent = 'center';
  });

  listMenus.forEach((menu) => {
    menu.style.display = 'inline-flex';
    menu.style.flexWrap = 'wrap';
  });

  // Hide on mobile initially
  if (window.innerWidth < 990) {
    inlineMenus.forEach((menu) => {
      menu.style.display = 'none';
    });
  }
});
